export const GRID_SIZES = {
    extraSmall: 'extraSmall',
    small: 'small',
    large: 'large',
    extraLarge: 'extraLarge'
};

export const DEFAULT_GRID_SIZE = GRID_SIZES.small;

export const NON_MODIFYING_QUERY_PARAMETERS = ['page', 'limit', 'grid'];

export const DEFAULT_PRODUCTS_PER_PAGE = 25;
